export enum FILE_EXTENSION {
  CSV = 'csv',
  DOCX = 'docx',
  DOC = 'doc',
  PDF = 'pdf',
  XLSX = 'xlsx',
  XLS = 'xls',
  DUMP = 'dump',
  ZIP = 'zip',
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  JSON = 'json'
}

export const supportedImageExtensions = [
  FILE_EXTENSION.PNG,
  FILE_EXTENSION.JPEG,
  FILE_EXTENSION.JPG
];

export const EXPORT_LIMIT = 10000;